import Vocabulary, { getVocabulary } from "components/Vocabulary";
import React from "react";
import { ARMORCODE_GROUP_KEY } from "utils/armorcodeGroupUtil";
import EnvironmentName from "views/GlobalSettings/EnvironmentName";
import { ToolCategory } from 'views/Integrations/ToolCategory';
import { find } from "utils/lodashUtils";
import { CellRenderers } from "utils/tableUtils";

export const FINDING_ACTIONS = {
  ACCEPT_RISK: "ACCEPT RISK",
  SUPPRESSED: "SUPPRESSED",
  TRIAGE:"TRIAGE",
  IN_PROGRESS:"IN_PROGRESS",
  CONTROLLED: "CONTROLLED",
  REJECT_RISK: "REJECT RISK",
  CONFIRMED: "CONFIRM",
  MITIGATED: "MITIGATED",
  NOT_CONFIRMED: "NOT CONFIRM",
  FALSEPOSITIVE: "FALSE POSITIVE",
  NOT_SUPPRESSED: 'NOT_SUPPRESSED',
  NOT_TRIAGE: 'NOT_TRIAGE',
  NOT_FALSEPOSITIVE: "NOT FALSE POSITIVE",
  NOT_IN_PROGRESS: "NOT_IN_PROGRESS",
  CHANGE_OWNER: "CHANGE OWNER",
  PROPOSE_FALSE_POSITIVE: "PROPOSE_FALSE_POSITIVE",
  PROPOSE_OPEN: "PROPOSE_OPEN",
  PROPOSE_CONFIRMED: "PROPOSE_CONFIRMED",
  PROPOSE_ACCEPTRISK: "PROPOSE_ACCEPTRISK",
  PROPOSE_SUPPRESSED: "PROPOSE_SUPPRESSED",
  PROPOSE_TRIAGE: "PROPOSE_TRIAGE",
  PROPOSE_IN_PROGRESS: "PROPOSE_IN_PROGRESS",
  PROPOSE_CONTROLLED: "PROPOSE_CONTROLLED",
  PROPOSE_MITIGATED: "PROPOSE_MITIGATED",
  PROPOSE_ASSIGNEE: "PROPOSE_ASSIGNEE",
  PROPOSE_DUE_DATE: "PROPOSE_DUE_DATE",
  PROPOSE_CATEGORY: "PROPOSE_CATEGORY",
  PROPOSE_SEVERITY: "PROPOSE_SEVERITY",
  PROPOSE_ACTION: "PROPOSE_ACTION",
  PROPOSE_BASIC_CHANGE: "PROPOSE_BASIC_CHANGE",
  PROPOSE_CUSTOM_FIELDS: "PROPOSE_CUSTOM_FIELDS",
  TAKE_ACTION_ON_PROPOSED_CUSTOM_FIELDS: "TAKE_ACTION_ON_PROPOSED_CUSTOM_FIELDS",
  ASSIGNED_OWNER: 'ASSIGNED_OWNER',
  DUE_DATE_UPDATE: 'DUE_DATE_UPDATE',
  TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK: "TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK",
  TAKE_ACTION_ON_PROPOSED_SUPPRESSED: "TAKE_ACTION_ON_PROPOSED_SUPPRESSED",
  TAKE_ACTION_ON_PROPOSED_TRIAGE: "TAKE_ACTION_ON_PROPOSED_TRIAGE",
  TAKE_ACTION_ON_PROPOSED_IN_PROGRESS: "TAKE_ACTION_ON_PROPOSED_INPROGRESS",
  TAKE_ACTION_ON_PROPOSED_CONTROLLED: "TAKE_ACTION_ON_PROPOSED_CONTROLLED",
  TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE: "TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE",
  TAKE_ACTION_ON_PROPOSED_OPEN: "TAKE_ACTION_ON_PROPOSED_OPEN",
  TAKE_ACTION_ON_PROPOSED_CONFIRMED: "TAKE_ACTION_ON_PROPOSED_CONFIRMED",
  TAKE_ACTION_ON_PROPOSED_DUE_DATE: "TAKE_ACTION_ON_PROPOSED_DUE_DATE",
  TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER: "TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER",
  TAKE_ACTION_ON_PROPOSED_MITIGATION: "TAKE_ACTION_ON_PROPOSED_MITIGATION",
  TAKE_ACTION_ON_PROPOSED_SEVERITY: "TAKE_ACTION_ON_PROPOSED_SEVERITY",
  TAKE_ACTION_ON_PROPOSED_CATEGORY: "TAKE_ACTION_ON_PROPOSED_CATEGORY",
  TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE: "TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE",
  ACTION_TAKEN: "ACTION_TAKEN"
}

//can be used to feature flag the finding actions
export const FINDING_ACTIONS_FLAGS = {
  CORRELATE_FINDINGS: "CORRELATED_FINDINGS"
}

export const REPORTED_ACTIONS = [
  FINDING_ACTIONS.REJECT_RISK,
  FINDING_ACTIONS.NOT_CONFIRMED,
  FINDING_ACTIONS.NOT_FALSEPOSITIVE
]

export const FINDING_STATUS = {
  OPEN: "OPEN",
  TRIAGE:"TRIAGE",
  CONFIRMED: "CONFIRMED",
  IN_PROGRESS:"IN_PROGRESS",
  ACCEPT_RISK: "ACCEPTRISK",
  FALSE_POSITIVE: "FALSEPOSITIVE",
  SUPPRESSED: "SUPPRESSED",
  CONTROLLED: "CONTROLLED",
  MITIGATED: "MITIGATED",
  CHANGE_OWNER: "CHANGEOWNER",
}

export const GLOBAL_STATUS = {
  OPEN: "open",
  ACCEPTRISK: "acceptRisk",
  CONFIRMED: "confirmed",
  FALSEPOSITIVE: "falsePositive",
  MITIGATED: "mitigated",
  CHANGEOWNER: "Change Owner",
  SUPPRESSED: "suppressed",
  TRIAGE: "triageStatus",
  IN_PROGRESS: "inProgressStatus",
  CONTROLLED: "controlledStatus"
}

export const OPTIONAL_STATUS = {
  CREATE_TICKETS: "CREATE_TICKETS",
  EDIT_BASIC_DETAILS: "EDIT_BASIC_DETAILS",
  BULK_EDIT_DETAILS: "BULK_EDIT_DETAILS",
  CHANGE_CATEGORY: "CHANGE_CATEGORY",
  CHANGE_SEVERITY: "CHANGE_SEVERITY",
  CHANGE_DUE_DATE: "CHANGE_DUE_DATE",
  CHANGE_OWNER: "CHANGE_OWNER",
  MITIGATED: "MITIGATED",
  CLEAR_BUCKET: "CLEAR_BUCKET",
  CHANGE_PROJECTS: "CHANGE_PROJECTS",
  CORRELATE_FINDINGS: "CORRELATE_FINDINGS",
  DETACH_TICKET: "DETACH_TICKET",
  ADD_TO_EXCEPTION: "ADD_TO_EXCEPTION",
  ADD_TO_ASSESSMENT: "ADD_TO_ASSESSMENT"
}

export const FINDING_PROPOSED_STATUS = {
  ...FINDING_STATUS,
  PROPOSE_OPEN: "PROPOSE_OPEN",
  PROPOSE_CONFIRMED: "PROPOSE_CONFIRMED",
  PROPOSE_ACCEPTRISK: "PROPOSE_ACCEPTRISK",
  PROPOSE_SUPPRESSED: "PROPOSE_SUPPRESSED",
  PROPOSE_TRIAGE: "PROPOSE_TRIAGE",
  PROPOSE_IN_PROGRESS: "PROPOSE_IN_PROGRESS",
  PROPOSE_CONTROLLED: "PROPOSE_CONTROLLED",
  PROPOSE_MITIGATED: "PROPOSE_MITIGATED",
  PROPOSE_ASSIGNEE: "PROPOSE_ASSIGNEE",
  PROPOSE_DUE_DATE: "PROPOSE_DUE_DATE",
  PROPOSE_FALSE_POSITIVE: "PROPOSE_FALSE_POSITIVE",
  PROPOSE_CATEGORY: "PROPOSE_CATEGORY",
  PROPOSE_SEVERITY: "PROPOSE_SEVERITY",
  PROPOSE_BASIC_CHANGE: "PROPOSE_BASIC_CHANGE",
  PROPOSE_BULK_EDIT_DETAILS: "PROPOSE_BULK_EDIT_DETAILS",
  PROPOSE_CUSTOM_FIELDS: "PROPOSE_CUSTOM_FIELDS",
  TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK: "TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK",
  TAKE_ACTION_ON_PROPOSED_SUPPRESSED: "TAKE_ACTION_ON_PROPOSED_SUPPRESSED",
  TAKE_ACTION_ON_PROPOSED_TRIAGE: "TAKE_ACTION_ON_PROPOSED_TRIAGE",
  TAKE_ACTION_ON_PROPOSED_IN_PROGRESS: "TAKE_ACTION_ON_PROPOSED_IN_PROGRESS",
  TAKE_ACTION_ON_PROPOSED_CONTROLLED: "TAKE_ACTION_ON_PROPOSED_CONTROLLED",
  TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE: "TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE",
  TAKE_ACTION_ON_PROPOSED_OPEN: "TAKE_ACTION_ON_PROPOSED_OPEN",
  TAKE_ACTION_ON_PROPOSED_CONFIRMED: "TAKE_ACTION_ON_PROPOSED_CONFIRMED",
  TAKE_ACTION_ON_PROPOSED_DUE_DATE: "TAKE_ACTION_ON_PROPOSED_DUE_DATE",
  TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER: "TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER",
  TAKE_ACTION_ON_PROPOSED_MITIGATION: "TAKE_ACTION_ON_PROPOSED_MITIGATION",
  TAKE_ACTION_ON_PROPOSED_SEVERITY: "TAKE_ACTION_ON_PROPOSED_SEVERITY",
  TAKE_ACTION_ON_PROPOSED_CATEGORY: "TAKE_ACTION_ON_PROPOSED_CATEGORY",
  TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE: "TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE"
}

export const UNRESOLVED_FINDING_STATUS = [FINDING_STATUS.OPEN, FINDING_STATUS.ACCEPT_RISK, FINDING_STATUS.CONFIRMED];

export const RESOLVED_FINDING_STATUS = [FINDING_STATUS.MITIGATED, FINDING_STATUS.FALSE_POSITIVE, FINDING_STATUS.SUPPRESSED];

export const NON_MITIDATED_FINDING_STATUS = [FINDING_STATUS.OPEN, FINDING_STATUS.ACCEPT_RISK, FINDING_STATUS.FALSE_POSITIVE, FINDING_STATUS.CONFIRMED, FINDING_STATUS.SUPPRESSED];

export const NON_FALSEPOSITIVE_FINDING_STATUS = [FINDING_STATUS.OPEN, FINDING_STATUS.ACCEPT_RISK, FINDING_STATUS.SUPPRESSED, FINDING_STATUS.MITIGATED, FINDING_STATUS.CONFIRMED];

export const NON_MITIGATED_NON_FALSEPOSITIVE = [FINDING_STATUS.OPEN, FINDING_STATUS.ACCEPT_RISK, FINDING_STATUS.CONFIRMED, FINDING_STATUS.IN_PROGRESS, FINDING_STATUS.TRIAGE];

export const OPTIONAL_DISPLAY_TEXT = {
  [OPTIONAL_STATUS.CREATE_TICKETS]: 'Create Ticket',
  [OPTIONAL_STATUS.EDIT_BASIC_DETAILS]: 'Edit Basic Information',
  [OPTIONAL_STATUS.BULK_EDIT_DETAILS]: 'Bulk edit finding details',
  [OPTIONAL_STATUS.CHANGE_CATEGORY]:  <>Change <Vocabulary name= "category" /></>,
  [OPTIONAL_STATUS.CHANGE_SEVERITY]: <>Change <Vocabulary name= "severity" /></>,
  [OPTIONAL_STATUS.CHANGE_DUE_DATE]: <>Change <Vocabulary name="resolution" /> Due Date</>,
  [OPTIONAL_STATUS.CHANGE_OWNER]: 'Change Owner',
  [OPTIONAL_STATUS.MITIGATED]: <Vocabulary name = "mitigated"/>,
  [OPTIONAL_STATUS.CLEAR_BUCKET]: 'Clear Bucket',
  [OPTIONAL_STATUS.CHANGE_PROJECTS] : <>Assign <Vocabulary name= "project"/></>,
  [OPTIONAL_STATUS.DETACH_TICKET] : "Detach Ticket",
  [OPTIONAL_STATUS.CORRELATE_FINDINGS] : "Correlate Findings",
  [OPTIONAL_STATUS.ADD_TO_EXCEPTION] : <>Add to <Vocabulary name= "exception"/></>,
  [OPTIONAL_STATUS.ADD_TO_ASSESSMENT] : <>Add to <Vocabulary name= "assessment"/></>,

}

export const FINDING_STATUS_DISPLAY_TEXT = {
  [FINDING_STATUS.OPEN]: <Vocabulary name = "open"/>,
  [FINDING_STATUS.FALSE_POSITIVE]: <Vocabulary name = "falsePositive"/>,
  [FINDING_STATUS.CONFIRMED]: <Vocabulary name = "confirmed"/>,
  [FINDING_STATUS.ACCEPT_RISK]: <Vocabulary name = "acceptRisk"/>,
  [FINDING_STATUS.CHANGE_OWNER]: "Change Owner",
  [FINDING_STATUS.MITIGATED]: <Vocabulary name = "mitigated"/>,
  [FINDING_STATUS.SUPPRESSED]: <Vocabulary name = "suppressed"/>,
  [FINDING_STATUS.TRIAGE]: <Vocabulary name = "triageStatus"/>,
  [FINDING_STATUS.IN_PROGRESS]: <Vocabulary name = "inProgressStatus"/>,
  [FINDING_STATUS.CONTROLLED]: <Vocabulary name = "controlledStatus"/>
}

// To be used where we cannot render Vocabulary directly, especially in charts
export const FINDING_STATUS_VOCABULARY_MAP = {
  [FINDING_STATUS.OPEN]: "open",
  [FINDING_STATUS.FALSE_POSITIVE]: "falsePositive",
  [FINDING_STATUS.CONFIRMED]: "confirmed",
  [FINDING_STATUS.ACCEPT_RISK]: "acceptRisk",
  [FINDING_STATUS.MITIGATED]: "mitigated",
  [FINDING_STATUS.SUPPRESSED]: "suppressed",
  [FINDING_STATUS.TRIAGE]: "triageStatus",
  [FINDING_STATUS.IN_PROGRESS]: "inProgressStatus",
  [FINDING_STATUS.CONTROLLED]: "controlledStatus"
}

// To be used where we cannot render Vocabulary directly, especially in charts
export const FINDING_PROPOSE_VOCABULARY_MAP = {
  [FINDING_PROPOSED_STATUS.PROPOSE_OPEN]: "open",
  [FINDING_PROPOSED_STATUS.PROPOSE_CONFIRMED]: "confirmed",
  [FINDING_PROPOSED_STATUS.PROPOSE_ACCEPTRISK]: "acceptRisk",
  [FINDING_PROPOSED_STATUS.PROPOSE_SUPPRESSED]: "suppressed",
  [FINDING_PROPOSED_STATUS.PROPOSE_TRIAGE]: "triageStatus",
  [FINDING_PROPOSED_STATUS.PROPOSE_IN_PROGRESS]: "inProgressStatus",
  [FINDING_PROPOSED_STATUS.PROPOSE_CONTROLLED]: "controlledStatus",
  [FINDING_PROPOSED_STATUS.PROPOSE_FALSE_POSITIVE]: "falsePositive",
  [FINDING_PROPOSED_STATUS.PROPOSE_MITIGATED]: "mitigated",
  [FINDING_PROPOSED_STATUS.PROPOSE_ASSIGNEE]: "owner",
  [FINDING_PROPOSED_STATUS.PROPOSE_SEVERITY]: "severity",
  [FINDING_PROPOSED_STATUS.PROPOSE_CATEGORY]: "category",

  // special handling needed
  [FINDING_PROPOSED_STATUS.PROPOSE_DUE_DATE]: "resolution",
  [FINDING_PROPOSED_STATUS.PROPOSE_BASIC_CHANGE]: "Propose Basic Information",
  [FINDING_PROPOSED_STATUS.PROPOSE_CUSTOM_FIELDS]: "Change Custom Fields",
};

// To be used where we cannot render Vocabulary directly, especially in charts
export const FINDING_VOCABULARY_TAKE_ACTION_MAP = {
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK]: "acceptRisk",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_SUPPRESSED]: "suppressed",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_TRIAGE]: "triageStatus",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_IN_PROGRESS]:"inProgressStatus",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_CONTROLLED]: "controlledStatus",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE]: "falsePositive",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_OPEN]: "open",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_CONFIRMED]: "confirmed",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_SEVERITY]: "severity",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_CATEGORY]: "category",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_MITIGATION]: "mitigated",

  // special handling needed
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_DUE_DATE]: "resolution",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER]: "owner",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE]: "Proposed Basic Information",
}

export const PROPOSE_MITIGATED_SUPPORTED_TOOLS = ["HackerOne", "Cobalt", "JIRA", "ArmorCode Code Insights"];

export const FINDING_STATUS_PROPOSED_DISPLAY_TEXT = {
  ...FINDING_STATUS_DISPLAY_TEXT,
  [FINDING_PROPOSED_STATUS.PROPOSE_OPEN]: <>Propose <Vocabulary name = "open"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_CONFIRMED]: <>Propose <Vocabulary name = "confirmed"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_ACCEPTRISK]: <>Propose <Vocabulary name = "acceptRisk"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_SUPPRESSED]: <>Propose <Vocabulary name = "suppressed"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_TRIAGE]: <>Propose <Vocabulary name = "triageStatus"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_IN_PROGRESS]: <>Propose <Vocabulary name = "inProgressStatus"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_CONTROLLED]: <>Propose <Vocabulary name = "controlledStatus"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_FALSE_POSITIVE]: <>Propose <Vocabulary name = "falsePositive"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_MITIGATED]: <>Propose <Vocabulary name = "mitigated"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_ASSIGNEE]: <>Propose <Vocabulary name = "owner"/></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_DUE_DATE]: <>Propose <Vocabulary name="resolution" /> Due Date</>,
  [FINDING_PROPOSED_STATUS.PROPOSE_SEVERITY]: <>Propose <Vocabulary name= "severity" /></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_CATEGORY]:  <>Propose <Vocabulary name="category" /></>,
  [FINDING_PROPOSED_STATUS.PROPOSE_BASIC_CHANGE]: "Propose Basic Information",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK]: <>Proposed <Vocabulary name = "acceptRisk"/></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_SUPPRESSED]: <>Proposed <Vocabulary name = "suppressed"/></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_TRIAGE]:<>Proposed <Vocabulary name = "triageStatus"/></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_IN_PROGRESS]:<>Proposed <Vocabulary name = "inProgressStatus"/></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_CONTROLLED]:<>Proposed <Vocabulary name = "controlledStatus"/></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE]: <>Proposed <Vocabulary name = "falsePositive"/></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_OPEN]: "Propose Re Open",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_CONFIRMED]: "Propose Confirmed",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_DUE_DATE]: <>Propose <Vocabulary name="resolution" /> Due Date</>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER]: "Propose Assign Owner",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_MITIGATION]: "Propose Mitigation",
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_SEVERITY]: <>Propose <Vocabulary name= "severity" /></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_CATEGORY]: <>Propose <Vocabulary name="category" /></>,
  [FINDING_PROPOSED_STATUS.TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE]: "Propose Basic Information",
  [FINDING_PROPOSED_STATUS.PROPOSE_CUSTOM_FIELDS]: "Change Custom Fields",
}

export const FINDING_STATUS_POST_ACTION_TEXT = {
  [FINDING_STATUS.OPEN]: <>Re-<Vocabulary name = "open"/></>,
  [FINDING_STATUS.FALSE_POSITIVE]: <>marked as <Vocabulary name = "falsePositive"/></>,
  [FINDING_STATUS.CONFIRMED]: <Vocabulary name = "confirmed"/>,
  [FINDING_STATUS.ACCEPT_RISK]: <>marked as <Vocabulary name = "acceptRisk"/></>,
  [FINDING_STATUS.SUPPRESSED]: <>marked as <Vocabulary name = "suppressed" /></>,
  [FINDING_STATUS.TRIAGE]: <>marked as <Vocabulary name = "triageStatus"/></>,
  [FINDING_STATUS.IN_PROGRESS]: <>marked as <Vocabulary name = "inProgressStatus"/></>,
  [FINDING_STATUS.CONTROLLED]: <>marked as <Vocabulary name = "controlledStatus"/></>,
  [FINDING_STATUS.CHANGE_OWNER]: <><Vocabulary name = "owner"/> Changed</>,
}

export const FINDING_TICKET_STATUS = {
  TO_BE_CREATED: "TO_BE_CREATED",
  SCHEDULER_RAN: "SCHEDULER_RAN",
  ERROR_OCCURRED: "ERROR_OCCURRED",
  CREATED: "CREATED",
  DONE: "DONE",
  CREATE_FAILED: "CREATE_FAILED",
  UPDATE_FAILED: "UPDATE_FAILED"
}

export const MAX_ACCEPT_RISK_COUNT = 3;

export const FINDING_ANALYSIS_TYPE = new Proxy({
  STATIC: "SAST",
  DYNAMIC: "DAST",
  NA: "N/A"
}, {
  get: (target, prop) => {
    return target?.[prop] ?? target.NA;
  }
});


export const TicketSystemType = {
  JIRA: "JIRA",
  AZURE_BOARD: "AZURE_BOARD",
  SERVICE_NOW: "SERVICE_NOW",
  VERSION_ONE: "VERSION_ONE",
  FRESH_SERVICE: "FRESHSERVICE",
  CONNECT_ALL: "CONNECT_ALL",
  ZENDESK: "ZENDESK",
  ASANA: "ASANA",
  ARCHER: "ARCHER",
  GITHUB_ISSUES: "GITHUB_ISSUES",
}

export const CREATE_TICKET_TITLE_UNSUPPORTED_TOOLS = [TicketSystemType.JIRA, TicketSystemType.FRESH_SERVICE, TicketSystemType.AZURE_BOARD, TicketSystemType.SERVICE_NOW, TicketSystemType.ASANA, TicketSystemType.ZENDESK]

export const REPORTER_FIELD_SUPPORTED_TOOLS = [TicketSystemType.JIRA, TicketSystemType.ZENDESK];

export const SUPPORTED_TICKET_CUSTOM_FIELD_TYPES = ["textarea", "userpicker", "textfield", "select"]

export const FINDING_UPDATE_TASK_TYPES = {
  ACCEPT_RISK: 'accept_risk',
  CONFIRMED: 'confirmed',
  FALSE_POSITIVE: 'false_positive',
  SUPPRESSED: "suppressed",
  OPEN: 'open',
  TRIAGE: 'triage',
  UPDATE_CATEGORY: 'update_category',
  UPDATE_SEVERITY: 'update_severity',
  IN_PROGRESS: 'in_progress',
  CONTROLLED:"controlled",
  PROPOSE_OPEN: 'propose_open',
  PROPOSE_CONFIRMED: 'propose_confirmed',
  PROPOSE_ACCEPTRISK: 'propose_accept_risk',
  PROPOSE_SUPPRESSED: 'propose_suppressed',
  PROPOSE_FALSEPOSITIVE: 'propose_false_positive',
  PROPOSE_MITIGATED: 'propose_mitigated',
  PROPOSE_ASSIGNEE: 'propose_owner',
  PROPOSE_DUE_DATE: 'propose_due_date',
  PROPOSE_TRIAGE: 'propose_triage',
  PROPOSE_IN_PROGRESS: 'propose_in_progress',
  PROPOSE_CONTROLLED: 'propose_controlled',
  PROPOSE_CUSTOM_FIELDS: 'propose_custom_fields',
}

export const FINDING_CATEGORY_TEXT = {
  BUG: "Bug",
  CODE_SMELL: "Code Smell",
  VULNERABILITY: "Vulnerability",
  UNCATEGORIZED: "Uncategorized",
  SECURITY_HOTSPOT: "Security Hotspot",
  COMPLIANCE: "Compliance",
  ATTACK:"Attack",
  SECURITY_MISCONFIGURATION:"Security Misconfiguration",
  SECRETS: "Secrets",
  LIBRARY_UPGRADE: "Library Upgrade",
  LICENSING:"Licensing"
}

export const SEVERITY_NAMES = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
  info: "Info",
}

export const BASE_SEVERITY_OBJECT = {
  [SEVERITY_NAMES.critical]: 0,
  [SEVERITY_NAMES.high]: 0,
  [SEVERITY_NAMES.medium]: 0,
  [SEVERITY_NAMES.low]: 0,
}

export const ALL_SEVERITIES = Object.values(SEVERITY_NAMES);

export const BASE_SEVERITIES = Object.keys(BASE_SEVERITY_OBJECT);

// please add the tool name always in lowercase
export const FUTURE_RULES_ACCEPTED_TOOLS_LIST = ['sonarqube', 'sonarcloud','fortify', 'snyk', 'prisma cloud twistlock', 'checkmarx', 'lacework', 'dependency check', 'qualys infrastructure', 'aws security hub', 'sonrai security', 'grammatech - codesonar']
export const FUTURE_RULES_ACCEPTED_TOOLS_SCANTYPES = {
  'prisma cloud twistlock': [ToolCategory.CONTAINER_SECURITY],
  'lacework': Object.values(ToolCategory).filter(key => ![ToolCategory.CSPM].includes(key)),
  'snyk': Object.values(ToolCategory).filter(key => ![ToolCategory.IAC].includes(key))
};
export const FUTURE_RULES_TOOLS_FIELDS_TO_CHECK = {
  'prisma cloud twistlock': ['cves']
};

export const TOOLS_NOT_FOR_FUTURE_FINDINGS = [];

export const DEFAULT_STATUS_FILTERS = [FINDING_STATUS.OPEN, FINDING_STATUS.ACCEPT_RISK, FINDING_STATUS.CONFIRMED];

// TODO - need either one of infra value, will update after backend is standardised.
export const INFRA_SCAN_TYPES = ["Infrastructure Tools", "Container Security", "CSPM", "IaC", "Endpoint Vulnerability Management"];

export const VOCABULARY_STATUS = ["open", "confirmed", "acceptRisk", "falsePositive", "mitigated", "suppressed", "triageStatus", "inProgressStatus", "controlledStatus"]

export const DEVELOPER_EMAIL_SUFFIX = 'armorcode.io';

export const Environments = [{
  label: <EnvironmentName name = "Production" />, value: "Production"},
  {label: <EnvironmentName name="staging" />, value: "Staging"  }
];

export function envParseSelectOptions(options) {
  return (options || []).map(option => ({label: <EnvironmentName name={option.name} />, value: option.id}))
};
export function envParseSelectOptionsWithValueAsName(options) {
  return (options || []).map(option => ({label: <EnvironmentName name={option.name} />, value: option.name}))
};

export const CAPITALIZED_SEVERITIES = ["Critical", "High", "Medium", "Low"];

export const UPPERCASE_SEVERITIES = {
  CRITICAL: "CRITICAL",
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
  INFO: "INFO",
}

export const MULTI_SORT_COLUMNS_LIMIT = 5
export const SIMILAR_FINDINGS_TAGS_OPERTAION_TYPES = {
  contains: 'CONTAINS',
  equals: 'EQUALS'
}

export const SIMILAR_FINDINGS_TYPES = {
  RULE_BASED: 'RULE_BASED',
  TAG_BASED: 'TAG_BASED'
}

export const TWISTLOCK_SOURCE = ['code', 'registry', 'image', 'host', 'ciImage'];

export const MANUAL_FINDING_MARK_DOWN_FIELDS = ['description', 'impact', 'mitigation', 'stepsToReproduce'];

export const ATTACHMENT_LINK_PREFIX = "!attachment!";

export const EXPLOIT_MATURITY_FILTERS = ["mature", "proof-of-concept", "no-known-exploit", "no-data", "NOT_DEFINED", "POC_CODE", "HIGH", "UNPROVEN", "FUNCTIONAL", "Highly functional"];


const KEY_TEXT = { ...OPTIONAL_STATUS, ...FINDING_PROPOSED_STATUS };
export const BULK_FINDING_ACTION_KEYS = KEY_TEXT;
export const BULK_FINDING_ACTION_MAP = {
  [KEY_TEXT.CREATE_TICKETS]: 'CREATE_TICKETS',
  [KEY_TEXT.FALSE_POSITIVE]: 'MARK_FALSE_POSITIVE',
  [KEY_TEXT.ACCEPT_RISK]: 'MARK_ACCEPT_RISK',
  [KEY_TEXT.CORRELATE_FINDINGS]: 'UPDATE_FINDINGS',
  [KEY_TEXT.EDIT_BASIC_DETAILS]: 'FINDINGS_UPDATE_BASIC_DETAILS',
  [KEY_TEXT.BULK_EDIT_DETAILS]: 'FINDINGS_UPDATE_BASIC_DETAILS',
  [KEY_TEXT.CHANGE_PROJECTS]: 'UPDATE_FINDINGS_PROJECT',
  [KEY_TEXT.CONFIRMED]: 'MARK_CONFIRM',
  [KEY_TEXT.MITIGATED]: 'MARK_MITIGATED',
  [KEY_TEXT.OPEN]: 'MARK_REOPEN',
  [KEY_TEXT.SUPPRESSED]: 'MARK_SUPPRESSED',
  [KEY_TEXT.TRIAGE]: "MARK_TRIAGE",
  [KEY_TEXT.IN_PROGRESS]: "MARK_IN_PROGRESS",
  [KEY_TEXT.CONTROLLED]: "MARK_CONTROLLED",
  [KEY_TEXT.CHANGE_CATEGORY]: 'UPDATE_CATEGORY',
  [KEY_TEXT.CHANGE_SEVERITY]: 'UPDATE_SEVERITY',
  [KEY_TEXT.CHANGE_DUE_DATE]: 'FINDINGS_CHANGE_DUE_DATE',
  [KEY_TEXT.CHANGE_OWNER]: 'ASSIGN_OWNER',
  [KEY_TEXT.DETACH_TICKET]: 'DELETE_TICKETS',
  [KEY_TEXT.PROPOSE_FALSE_POSITIVE]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_CATEGORY]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_SEVERITY]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_ACCEPTRISK]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_SUPPRESSED]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_MITIGATED]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_ASSIGNEE]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_DUE_DATE]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_BASIC_CHANGE]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_TRIAGE]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_IN_PROGRESS]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_CONTROLLED]: 'PROPOSE',
  [KEY_TEXT.PROPOSE_CUSTOM_FIELDS]: 'PROPOSE',
  // [KEY_TEXT.CLEAR_BUCKET]: undefined,
  // "clear-bucket": undefined
}

export const BULK_ACTION_DISPLAY_TEXT = { ...OPTIONAL_DISPLAY_TEXT, ...FINDING_STATUS_PROPOSED_DISPLAY_TEXT };

export const WIDE_INTERNET_ACCESS_TAG_KEY = "wiz.opentoallinternet";

export const FINDINGS_OVER_TIME_SUPPORTED_FILTERS = ["source", "scanType", "productStatus", "subProductStatuses", "keyValue"];

export const ARMORCODE_PRIMARY_CORRELATED_FINDING = "armorcode.primary_correlated_finding";
// This keys are not allowed to be entered while defining findings tags
export const RESERVED_TAG_KEYS = [ARMORCODE_GROUP_KEY, "wiz.image_tag","crowdstrike.image_tags"];

export const FINDING_SCORE_SEVERITY_WEIGHT = {
  CRITICAL: 10,
  HIGH: 8,
  MEDIUM: 5,
  LOW: 1,
  INFO: 0,
};

export const SSDLC_WEIGHT = {
  MAX: 10,
  HIGH: 8,
  MEDIUM: 5,
  LOW: 1,
};

export const SLA_STATUS_FILTERS_WITHOUT_NA = [
  { name: "Failed", id: "FAIL" }, 
  { name: "Pass", id: "PASS" },
  { name: "In Progress", id: "IN_PROGRESS"},
]

export const SLA_STATUS_FILTERS = [
  ...SLA_STATUS_FILTERS_WITHOUT_NA,
  { name: CellRenderers.VALUE_OR_NA(), id: null },
];


export const RENDER_FINDING_SLA_STATUS_FILTERS = (status) => find(SLA_STATUS_FILTERS, slaStatus => slaStatus.id === status)?.name || status

export const DATE_FILTER_API_SUPPORT = ["foundOn", "lastModifiedDate", "lastUpdated", "issueResolved", "unsupressTime", "publishedDate", "lastTriagedDate", "lastSuppressDate", "lastConfirmDate", "lastFalsePositiveDate", "lastAcceptRiskDate", "lastOpenDate", "cisaDueDate", "lastSeenDate", "slaDueDate", "triageDueDate", "remediationDueDate", "exceptionsStartDate", "exceptionsEndDate"];

export const DUE_DATE_KEYS = ["slaDueDate", "triageDueDate", "remediationDueDate"];
export const DISABLE_TOTAL_IN_COLUMNS = ['tags', 'cve', 'cwesStrings', ARMORCODE_GROUP_KEY];

export const KEYS_WITH_IDS = ["product", "subProduct", "team", "armorcodeProjects"];

export const KEYS_NOT_TO_POPULATE_IN_STATS = [...DATE_FILTER_API_SUPPORT, ...DUE_DATE_KEYS];

export const checkIfSLADueDateColumns = (column) => [...DUE_DATE_KEYS].indexOf(column) !== -1;

export const checkIfSLAStatusColumns = (column) => ["triageSlaStatus", "resolutionSlaStatus", "remediationSlaStatus"].indexOf(column) !== -1;

// Refer to ENG-98774 for the order of finding columns if any changes made to below default hidden columns
export const DEFAULT_HIDDEN_COLUMN_KEYS = [
  "description",
  "unsupressTime",
  "aatiScore",
  "cve",
  "scan",
  "baseScore",
  "exploitabilityScore",
  "impactScore",
  "cwesStrings",
  "foundOn",
  "lastConfirmDate",
  "lastFalsePositiveDate",
  "lastOpenDate",
  "lastAcceptRiskDate",
  "lastSuppressDate",
  "productStatus",
  "subProductVersion",
  "subProductStatuses",
  "environmentName",
  "team",
  "businessOwner",
  "securityOwner",
  "engineeringOwner",
  "supportOwner",
  "complianceOwner",
  "armorcodeProjects",
  "riskRegister",
  "armorcodeTicketStatus",
  "vendor",
  "toolId",
  "url",
  "toolSeverity",
  "toolFindingStatus",
  "findingCategory",
  "keyValue",
  "componentName",
  "componentVersion",
  "componentFixVersions",
  "fixability",
  "SNYK_exploitMaturity",
  "repositoryName",
  "filePath",
  "lineNumber",
  "developer",
  "vmHostName",
  "newUrl",
  "containerImageName",
  "Twistlock_originType",
  "Twistlock_scanType",
  "ruleId",
  "policy",
  "lastUpdated",
  "issueResolved",
  "exploited",
  "XRay_Path",
  "XRay_Impacted_Artifact",
  "lastTriagedDate",
  "assetScore",
  "vmHostIpAddresses",
  "cvssVector",
  "epssScore",
  "isCISAKEV",
  "cisaDueDate",
  "lastSeenDate",
  "versionFindingsCount",
  "correlatedFindingsCount",
  "ctiScore",
  "remediationDueDate",
  "triageDueDate",
  "statusChangeReason",
  'exceptions',
  "ticketOwnerNames",
  "exceptionsId",
  "exceptionsStartDate",
  "exceptionsEndDate",
  "exceptionsReason",
  "exceptionsStatus",
  "lastModifiedDate",
  "publishedDate",
  "lastResolutionNote",
  "resolutionSlaStatus",
  "assessments",
  "correlationName",
  "remediationAction",
  "mitigation",
  "impact",
  "stepsToReproduce",
  "riskRating",
  "lastScanDate",
  "epssProbability",
  "mobbFixUrl",
  "cvssOverallScore",
  "lastControlledDateTime",
  "lastInProgressDateTime",
  "craExploitStatus",
  "craNotificationStatus",
  "craEarlyWarningDue",
  "craNotificationDue",
  "craFinalReportDue",
  "craUserDisclosureDue",
  "craUserDisclosureStatus",
  "craRemediationEvidence",
];

export const GroupBySupportedFieldsFlagNames = {
  assetType: "RBVM_ASSETS",
  assetName: "RBVM_ASSETS",
  riskRating: "RISK_SCORE_3_0",
  owaspTop10_2021: "OWASP_CWE_FILTER",
  cweTop25_2024: "OWASP_CWE_FILTER",
  craExploitStatus: "CRA",
  craNotificationStatus: "CRA",
  craUserDisclosureStatus: "CRA",
}

export const GroupBySupportedFields = [
  "componentName",
  "componentFixVersions",
  "componentVersion",
  "cve",
  "cwesStrings",
  "vmHostName",
  "exploited",
  "containerImageName",
  "product",
  "scanType",
  "severity",
  "source",
  "status",
  "subProduct",
  "title",
  "slaDueDate",
  "triageDueDate",
  "remediationDueDate",
  "resolutionSlaStatus",
  "triageSlaStatus",
  "remediationSlaStatus",
  "armorcodeCategory",
  "tags",
  "isCISAKEV",
  "team",
  "assetType",
  "assetName",
  ARMORCODE_GROUP_KEY, 
  "armorcodeProjects",
  "developer",
  "correlationName",
  "remediationAction",
  "repositoryName",
  "armorcodeTicket",
  "filePath",
  "riskRating",
  "owaspTop10_2021",
  "cweTop25_2024",
  "craExploitStatus",
  "craNotificationStatus",
  "craUserDisclosureStatus",
];

// there are others as well, but these are used in group by
export const PartialSearchSupportedFields = [
  "cve",
  "cwesStrings",
  "vmHostName",
  "containerImageName",
  "title",
  "correlationName",
  "repositoryName",
  "armorcodeTicket",
  "filePath",
];

const testTypeOptions = [
  "Vulnerability",
  "API Test",
  "Static Check",
  "Pen Test",
  "Web Application Test",
  "Security Research",
  "Threat Modeling",
  "Manual Code Review",
  "Security Hotspot",
  "Code Smell",
  "Bug",
  "Security Requirements",
  "Risk Assessment",
  "Compliance"
];

export {
  testTypeOptions as TOOL_FINDING_CATEGORIES
}

export const scanTypeOptions = [
  "SCA",
  "DAST",
  "Bug Bounty",
  "Pentesting Framework",
  "MAST",
  "Infrastructure Tools",
  "SAST",
  "Container Security",
  "SBOM",
  "IAST",
  "CSPM",
  "IaC",
  "Secrets"
];

export const EXPLOITED_OPTIONS = [{ label: 'True', value: true }, {label: "False", value: false}];

export const DEFAULT_DATE_FORMATS = {
  lastUpdated: "relativeTime",
  cisaDueDate: "date",
  lastSeenDate: "date",
  lastTriagedDate: "date",
  foundOn: "date",
  slaDueDate: "date",
  craEarlyWarningDue: "date",
  craNotificationDue: "date",
  craFinalReportDue: "date",
  craUserDisclosureDue: "date"
}

export const getCustomColumnTitles = () => {
  return {
    [ARMORCODE_GROUP_KEY]: getVocabulary("group"),
    triageSlaStatus: `${getVocabulary("triage")} SLA Status`,
    remediationSlaStatus: `${getVocabulary("remediation")} SLA Status`,
    resolutionSlaStatus: `${getVocabulary("resolution")} SLA Status`,
    tags: "Tags",
    assetType: "Asset Type",
    assetName: "Asset Name",
    correlationName: "Remediation Group",
    remediationAction: "Remediation Action",
    riskRating: "Risk Rating",
    owaspTop10_2021: "OWASP Top 10 - 2021",
    cweTop25_2024: "CWE Top 25 - 2024"
  };
}

export const IPAdressFilterMessage = (
  <>
    <span>Examples:</span>
    <br />
    <span>Single IP: 10.0.0.1</span>
    <br />
    <span>Mutiple IP: 10.0.0.2,10.0.0.7,10.0.0.9</span>
    <br />
    <span>Single IP Range: 10.0.0.1-10.0.0.20</span>
    <br />
    <span>Mutiple IP Ranges: 10.0.0.1-10.0.0.20,100.0.10.1-100.0.10.150</span>
    <br />
  </>
);

export const TAG_GROUP_DISABLE_MESSAGE = "To activate tag grouping, please set a tag filter in the page-level filter area above";
export const TOOLS_WITHOUT_ATTACHMENT_SUPPORT = ["GITHUB_ISSUES", "PAGERDUTY", "ARCHER"];

export const CUSTOM_COLUMN_PREFIX = "keyValue.";

export const SPECIFIC_FIELD = ["TOOL_SEVERITY", "TOOL_FINDING_CATEGORY", "TOOL_FINDING_ID", "CODE_REPO_LINK", "TOOL_FINDING_STATUS", "SCAN_ID", "TOOL_FINDING_STATUS_ORIGINAL", "TOOL_FINDING_SUB_STATUS_ORIGINAL"];

export const TOOL_TYPE_SPECIFIC_FIELDS = {
  "Bug Bounty" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "ENDPOINT"],
  "IaC" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "FILE_NAME", "LINE_NUMBER", "AUTHOR_DEVELOPER"],
  "Container Security" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "FILE_NAME", "COMPONENT_NAME", "COMPONENT_VERSION", "IMAGE_NAME", "FIXABLE_USING_TOOL", "EXPLOIT_MATUARITY", "LINE_NUMBER", "AUTHOR_DEVELOPER"],
  "Infrastructure Tools" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "COMPONENT_NAME", "COMPONENT_VERSION", "DEVICE_HOST_NAME", "IP_ADDRESSES"],
  "SCA" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "FILE_NAME", "COMPONENT_NAME", "COMPONENT_VERSION", "FIXABLE_USING_TOOL", "EXPLOIT_MATUARITY","LINE_NUMBER","AUTHOR_DEVELOPER"],
  "SAST" : [...SPECIFIC_FIELD, "FILE_NAME", "LINE_NUMBER","AUTHOR_DEVELOPER"],
  "DAST" : [...SPECIFIC_FIELD,"COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "FILE_NAME", "ENDPOINT"],
  "CSPM" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION","DEVICE_HOST_NAME"],
  "CSPM(Lacework)" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION"],
  "IAST" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "ENDPOINT"],
  "Threat Model" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION"],
  "MAST" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION"],
  "Threat Intelligence" : [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION", "DEVICE_HOST_NAME", "ENDPOINT"],
  "Secrets": [...SPECIFIC_FIELD, "FILE_NAME", "LINE_NUMBER","DEVICE_HOST_NAME"],
  "SBOM": [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION", "COMPONENT_FIX_VERSION"],
  "Code Insights": [...SPECIFIC_FIELD, "FILE_NAME", "LINE_NUMBER", "AUTHOR_DEVELOPER"],
  "Data Security": [...SPECIFIC_FIELD,"DEVICE_HOST_NAME"],
  "EASM": [...SPECIFIC_FIELD,"DEVICE_HOST_NAME"],
  "License": [...SPECIFIC_FIELD, "COMPONENT_NAME", "COMPONENT_VERSION"],
};

export const ATTACHMENT_TOOLS = ["HackerOne", "Fortify", "Bugcrowd", "Edgescan", "Cobalt"];